export class OperatorModel {
  operatorId?: number;
  operatorName?: string;
  addressline1?: string;
  addressline2?: string;
  operatorPincode?: string;
  operatorCity?: string;
  operatorState?: string;
  operatorCountry?: string;
  taxDescription?: string;
  taxrate1?: string;
  creationDate?: Date;
  config?:string;
  email?:string;
  fileData?:string;
  lastModificationDate?: Date;
  parentOperator?: OperatorModel;
}
